<div class="stepper-wrapper">
  <p-stepper [value]="stepPanel.PanelOne" class="basis-[50rem]">
    <p-step-list>
      <p-step [value]="stepPanel.PanelOne" [disabled]="true">Artículos del Pedido</p-step>
      <p-step [value]="stepPanel.PanelTwo" [disabled]="true">Artículo a Remisionar</p-step>
    </p-step-list>
    <p-step-panels>
      <p-step-panel [value]="stepPanel.PanelOne">
        <ng-template #content let-activateCallback="activateCallback">
          <div class="container-style">
            @if (loading) {
            <div class="p-4">
              <p-skeleton styleClass="custom-skeleton-header"></p-skeleton>
              <p-skeleton styleClass="custom-skeleton-body"></p-skeleton>
            </div>
            } @else {
            <app-custom-table [showRecover]="true" [radioButton]="true" [showCheckbox]="true" [isMultipleSelect]="false"
              [data]="dataArticle" [headers]="headerArticle" [previousFilters]="filtersArticle"
              [actions]="tableActions" (onAction)="onAction($event)"
              (onRecoverData)="getOrderArticlesStockForSelection()" (selectionChange)="onArticleSelectionChange($event)"
              (onPageChange)="onPageChange($event)" (onFilterChange)="onFilterChange($event)">
            </app-custom-table>
            }
          </div>
          <div class="d-flex justify-content-end mt-2">
            <app-custom-button [width]="'7'" [severity]="'contrast'" [label]="'Siguiente'" [icon]="'pi pi-arrow-right'"
              (onClick)="goToStep(stepPanel.PanelTwo, activateCallback)">
            </app-custom-button>
          </div>
        </ng-template>
      </p-step-panel>
      <p-step-panel [value]="stepPanel.PanelTwo">
        <ng-template #content let-activateCallback="activateCallback">
          <div class="container-style mb-2">
            @if (selectedArticle) {
            <div class="row mx-2">
              <div class="col-12 col-sm-6 col-lg-2">
                <small class="text-muted d-block">Pedido</small>
                <span class="fw-medium">{{ selectedArticle.orderCode }}</span>
              </div>
              <div class="col-12 col-sm-6 col-lg-2">
                <small class="text-muted d-block">Código</small>
                <span class="fw-medium">{{ selectedArticle.articleCode }}</span>
              </div>
              <div class="col-12 col-sm-6 col-lg-4">
                <small class="text-muted d-block">Artículo</small>
                <span class="fw-medium text-truncate d-block" [title]="selectedArticle.articleName">{{
                  selectedArticle.articleName }}</span>
              </div>
              <div class="col-6 col-sm-3 col-lg-2">
                <small class="text-muted d-block">Cant. Pedido</small>
                <span class="fw-medium">{{ selectedArticle.quantityFinal | number:'1.2-2' }}</span>
              </div>
              <div class="col-6 col-sm-3 col-lg-2">
                <small class="text-muted d-block">Cant. Pendiente</small>
                <span class="fw-medium text-warning">{{ selectedArticle.quantityPending | number:'1.2-2' }}</span>
              </div>
            </div>
            }
          </div>
          <div class="container-style">
            <app-custom-table [showRecover]="true" [showCheckbox]="true" [isMultipleSelect]="true"
              [data]="dataStoreStock" [headers]="headerStoreStock" [previousFilters]="filtersStoreStock"
              [dataKey]="'id'" [clearSelectionTrigger]="clearSelectionTrigger"
              (onRecoverData)="getStoreStockByArticleForSelection()" (onPageChange)="onPageChange($event)"
              (onFilterChange)="onFilterChange($event)" (selectionChange)="onStoreStockSelectionChange($event)">
            </app-custom-table>
          </div>
          <div class="d-flex mt-2 justify-content-start">
            <app-custom-button [width]="'7'" [label]="'Regresar'" [severity]="'contrast'" [icon]="'pi pi-arrow-left'"
              (onClick)="goToStep(stepPanel.PanelOne, activateCallback)">
            </app-custom-button>
          </div>
        </ng-template>
      </p-step-panel>
    </p-step-panels>
  </p-stepper>
  <app-custom-modal #orderDataModal [header]="'Datos del Pedido'" [width]="'60vw'"
    [inputs$]="inputsForOrderDataModal$" [children]="componentOrderData" hidden>
  </app-custom-modal>
</div>